import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import IssueCategoryMenu from '../../../components/Settings/IssueCategoryMenu';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_ISSUE_CATEGORY from '../../../api/apiIssueCategory';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    SETTING_ISSUE_CATEGORY_DELETE,
    SETTING_ISSUE_CATEGORY_INSERT,
    SETTING_ISSUE_CATEGORY_UPDATE,
    SETTING_ISSUE_CATEGORY_VIEW
} from '../../../constants/menuPermissionConstant';

class Product extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Produk",
                    dataIndex: "complaint_description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, productDataSelectedEdit: data, product: data.complaint_description })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, productDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listProduct: [],
            product: '',
            productDataSelectedEdit: {},
            productDataSelectedDelete: {},
            showWarningProduct: false,
            showAddModal: false,
            showEditModal: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateProduct();
                this.getListProduct(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateProduct();
                this.getListProduct(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getInitiateProduct = () => {
        API_ISSUE_CATEGORY.getInitiateProduct(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListProduct = (current, pageSize) => {
        API_ISSUE_CATEGORY.getListProduct(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listProduct: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningProduct: false,
            product: ''
        });
    }

    handleConfirmAddProduct = () => {
        if (!this.state.product) return this.setState({ showWarningProduct: true });
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddProduct = () => {
        const data = {
            complaint_description: this.state.product
        }

        API_ISSUE_CATEGORY.postDataProduct(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        product: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddProduct = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateProduct();
            this.getListProduct(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditProduct = () => {
        if (!this.state.product) return this.setState({ showWarningProduct: true });
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditProduct = () => {
        const productId = this.state.productDataSelectedEdit.id;
        const data = {
            complaint_description: this.state.product,
            updated_at: this.state.productDataSelectedEdit.updated_at
        }

        API_ISSUE_CATEGORY.putDataProduct(productId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        product: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditProduct = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateProduct();
            this.getListProduct(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeleteProduct = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const productId = this.state.productDataSelectedDelete.id;
        const data = {
            updated_at: this.state.productDataSelectedDelete.updated_at
        }
        API_ISSUE_CATEGORY.deleteDataProduct(productId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteProduct = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateProduct();
            this.getListProduct(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateProduct();
        this.getListProduct(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="Kategori Masalah"
                        title="Produk"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <IssueCategoryMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center h-12">
                                    {/* Add Product Button */}
                                    <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnaddproduct" onClick={() => this.setState({ showAddModal: true })} className="flex items-center text-white py-2 px-6 rounded-md bg-nexcaredefault cursor-pointer">
                                            <IconAddTransparent />
                                            <span className="ml-2">Produk</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>

                                {/* Table Product */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listProduct}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add Product Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah Produk</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Produk <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslproductadd"
                                        className="form-control"
                                        placeholder="Tulis Produk"
                                        name="product"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningProduct: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.product}
                                    />
                                    {this.state.showWarningProduct && <MandatoryAlert text="Produk tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddproduct" onClick={this.handleConfirmAddProduct}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit Product Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Produk</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Produk <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslproductedit"
                                        className="form-control"
                                        placeholder="Tulis Produk"
                                        name="product"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningProduct: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.product}
                                    />
                                    {this.state.showWarningProduct && <MandatoryAlert text="Produk tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditproduct" onClick={this.handleConfirmEditProduct}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan Produk" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddProduct} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddProduct} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Produk" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditProduct} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditProduct} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus Produk" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, productDataSelectedDelete: {} })} submit={this.handleDeleteProduct} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteProduct} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);